<template>
  <video-bg :sources="['public/video/landing.mp4']">
    <v-layout column align-center justify-center class="white--text sloganPos">
      <img v-if="$vuetify.breakpoint.mdAndUp" src="public/icons/EW_logo.png" height="200">
      <img v-else src="public/icons/EW_logo.png" height="150">
      <div v-if="$vuetify.breakpoint.mdAndUp" class="font-title text-xs-center">EW Virtual</div>
      <div v-else class="font-heading text-xs-center">EW Virtual</div>
      <div v-if="$vuetify.breakpoint.mdAndUp" v-lang.slogan class="font-heading text-xs-center"></div>
      <div v-else v-lang.slogan class="font-subheading text-xs-center"></div>
    </v-layout>
  </video-bg>
</template>

<script>
import VideoBg from "vue-videobg";
export default {
  data() {
    return {};
  },
  components: {
    VideoBg
  }
};
</script>

<style>
.sloganPos {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue